export const ONE_TIME_PASSWORD = 'one_time_password';
export const EXCHANGE_TOKEN = 'exchange_token';
export const OTP = 'OTP';

/** The otpType used by otpSend SDK action */
export const OTP_TYPES = {
  ID_EMAIL: 'ID_EMAIL',
  ID_PASSWORD: 'ID_PASSWORD',
  ID_PHONE: 'ID_PHONE',
  EMAIL_PHONE: 'EMAIL_PHONE',
  CASE_ONLY: 'CASE_ONLY',
};

export default { ONE_TIME_PASSWORD, EXCHANGE_TOKEN, OTP, OTP_TYPES };
